import { Link } from 'react-router-dom';
import type { Tier2Factor } from '@/types/analytics';

// All percent values from the bottleneck API are already 0–100, not 0–1.
function formatValue(value: unknown, format: Tier2Factor['format']): string {
  if (value === null || value === undefined) return '—';
  const n = Number(value);
  if (isNaN(n)) return '—';
  switch (format) {
    case 'percent':   return `${n.toFixed(1)}%`;
    case 'minutes':   return `${n.toFixed(0)} min`;
    case 'days':      return `${n.toFixed(1)}d`;
    case 'currency':  return `$${n.toFixed(2)}`;
    case 'count':     return n.toLocaleString();
    case 'breakdown': return 'See detail';
    default:          return String(n);
  }
}

interface Tier2PanelProps {
  factors: Tier2Factor[];
  // Flat map of factor.key → raw value (pre-resolved by AnalyticsDashboard)
  data: Record<string, unknown>;
}

export function Tier2Panel({ factors, data }: Tier2PanelProps) {
  if (factors.length === 0) return null;

  return (
    <div className="border-t border-border/60 px-4 py-3 bg-muted/20">
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        {factors.map((factor) => {
          const raw = data[factor.key];
          const display = formatValue(raw, factor.format);
          return (
            <div key={factor.key} className="space-y-0.5 min-w-0">
              <p className="text-[10px] font-medium uppercase tracking-wide text-muted-foreground/70 leading-tight whitespace-normal break-words">
                {factor.label}
              </p>
              <p className="text-sm font-semibold">{display}</p>
              <Link
                to={factor.link}
                className="text-[10px] text-muted-foreground/60 hover:text-foreground block transition-colors"
                onClick={(e) => e.stopPropagation()}
              >
                View detail →
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
}
